import { createBreakpoints } from '@chakra-ui/theme-tools';
import {
  smallDeviceWidth,
  medium745DeviceWidth,
  mediumDeviceWidth,
  largeDeviceWidth,
  doubleLargeDeviceWidth,
} from '@Utils/commonParameters';

export default createBreakpoints({
  sm: `${smallDeviceWidth}px`,
  md: `${medium745DeviceWidth}px`,
  lg: `${mediumDeviceWidth}px`,
  xl: `${largeDeviceWidth}px`,
  '2xl': `${doubleLargeDeviceWidth}px`,
});
